import request from '../util/request';

export const incomeList = (data) => request.post('/api/finance/income/list', data);
export const incomeDetail = (snapshotId) => request.get(`/api/finance/income/${snapshotId}`);
export const incomeExport = (data) => request.post('/api/finance/income/export', data);

export const withdrawList = (data) => request.post('/api/finance/withdraw/list', data);
export const withdrawDetail = (id) => request.get(`/api/finance/withdraw/${id}`);
export const withdrawExport = (data) => request.post('/api/finance/withdraw/export', data);

export const vatList = (data) => request.post('/api/finance/vat/list', data);
export const vatOrders = (params) =>
  request.get('/api/finance/vat/orders', { params });
export const vatStatusUpdate = (data) => request.put('/api/finance/vat/status', data);
export const vatExport = (data) => request.post('/api/finance/vat/export', data);

export const authList = (data) => request.post('/api/finance/auth/list', data);
export const authDetail = (id) => request.get(`/api/finance/auth/${id}`);
export const authExport = (data) => request.post('/api/finance/auth/export', data);

export const orderList = (data) => request.post('/api/finance/order/list', data);
export const orderExport = (data) => request.post('/api/finance/order/export', data);

export const exportTaskStatus = (taskNo) => request.get(`/api/finance/export/${taskNo}`);
export const exportDownloadUrl = (taskNo) => `/api/finance/export/${taskNo}/download`;
